import { Download, RemoveRedEye } from "@mui/icons-material";
import { Grid } from "@mui/material";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { getInfoEstructuraArchivo, getTemplateNomina, importarNomina } from "../../../redux/actions/nomina";
import { downloadFile } from "../../../util/files";
import DropZone from "../../commons/dropZone/DropZone";
import PdfDialog from "../../commons/file/PdfDialog";
import HeaderForm from "../../commons/labels/HeaderForm";
import FeatureLabel from "../../prevencion/nte/commons/labels/FeatureLabel";
import { StyledNominaMasiva } from "../../styled/Personal";
import ErrorDialog from "./ErrorDialog";

const NominaMasiva = () => {
  const dispatch = useDispatch();

  const nominaState = useSelector((state) => state.nomina.nomina);
  const templateNomina = useSelector((state) => state.nomina.templateNomina);
  const infoEstructuraArchivo = useSelector((state) => state.nomina.infoEstructuraArchivo);

  const [nomina, setNomina] = useState(null);
  const [openError, setOpenError] = useState(false);
  const [errors, setErrors] = useState([]);
  const [showPdfDialog, setShowPdfDialog] = useState(false);

  useEffect(() => {
    dispatch(getTemplateNomina())
  }, [dispatch, templateNomina.data]);

  const handleSubmit = () => {
    const body = {
      base64: nomina[0].value,
    };
    dispatch(importarNomina(body)).then((res) => {
      if (res?.value?.data && Array.isArray(res.value.data)) {
        setErrors(res.value.data);
        setOpenError(true);
      } else {
        toast.success("Nóminas importadas correctamente");
        setNomina(null);
      }
    });
  };

  const handleCloseError = () => {
    setOpenError(false);
    setErrors([]);
  };

  const handleDownloadTemplate = () => {
    dispatch(getTemplateNomina()).then(() => {
      if (templateNomina.data) {
        downloadFile(templateNomina.data, "template_nomina_masiva.csv");
      }
    });
  };

  const handleGetInfoEstructura = () => {
    dispatch(getInfoEstructuraArchivo());
    setShowPdfDialog(true);
  };

  return (
    <StyledNominaMasiva.Container>
      <HeaderForm title="Importar Nóminas" />
      <DropZone
        onUpload={handleSubmit}
        file={nomina}
        setFile={setNomina}
        loading={nominaState.loading}
        extension=".csv"
        accept={{
          "text/csv": [".csv"],
        }}
        dropZoneText="Arrastre la nómina en formato .csv aquí o haga click en el recuadro para
        adjuntarla."
        dropZoneEditText="Si desea cambiar el archivo arrastrelo nuevamente o haga click en
        el recuadro."
      />
      <Grid container justifyContent="space-between" style={{ padding: 20 }}>
        <Grid item>
          <FeatureLabel
            labelText={"Información del Archivo a Importar"}
            color="primary"
            icon={<RemoveRedEye />}
            onClick={handleGetInfoEstructura}
            tooltipText={"Información del Archivo a Importar"}
          />
        </Grid>
        <Grid item>
          <FeatureLabel
            labelText={"Descargar Template en Formato .CSV"}
            icon={<Download />}
            onClick={handleDownloadTemplate}
            tooltipText={"Descargar .csv"}
          />
        </Grid>
      </Grid>
      <PdfDialog
        title={"Información del Archivo a Importar"}
        file={infoEstructuraArchivo.data ? infoEstructuraArchivo.data.base64 : null}
        open={showPdfDialog}
        handleClose={() => setShowPdfDialog(false)}
         controllers={false}
      />
      <ErrorDialog
        open={openError}
        handleClose={handleCloseError}
        errors={errors}
      />
    </StyledNominaMasiva.Container>
  );
};

export default NominaMasiva;
